export default {
      id: "sli-close2-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.43681d49.svg#sli-close2",
      toString: function () {
        return this.url;
      }
    }